// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';

// Services
import ContentReactionService from '@/app/services/main/content-reaction/content-reaction-service.js';

// Third Party libraries
import * as $ from 'jquery';

export default {
    name: 'reactionSummaryModal',
    mixins: [
        toastMessageMixins,
        tableMixins
    ],
    props: {
        reactionDetails: {
            required: true
        },
        feedId: {
            required: true
        }
    },
    data() {
        return {
            isAPILoading: false,
            searchMember: '',
            tabs: [
                {
                    id: 0,
                    label: 'All',
                    active: true
                },
                { 
                    id: 1,
                    label: 'Like',
                    active: false,
                    type: require('@/assets/images/social-club/like.png'),
                    count:0
                },
                { 
                    id: 2,
                    label: 'Heart',
                    active: false,
                    type:require('@/assets/images/social-club/heart.png'),
                    count:0
                },
                { 
                    id: 3,
                    label: 'Haha',
                    active: false,
                    type:require('@/assets/images/social-club/haha.png'),
                    count:0
                },
                { 
                    id: 4,
                    label: 'Wow',
                    active: false,
                    type:require('@/assets/images/social-club/wow.png'),
                    count:0
                },
                { 
                    id: 5,
                    label: 'Sad',
                    active: false,
                    type: require('@/assets/images/social-club/crying.png'),
                    count:0
                },
                { 
                    id: 6,
                    label: 'Angry',
                    active: false,
                    type: require('@/assets/images/social-club/mad.png'),
                    count:0
                }
            ],
            reactionsList: [],
            page: 1,
            infiniteId: +new Date()
        }
    },
    computed: {
        getActiveTab() {
            return this.tabs.find(tab => tab.active);
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        openModal() {
            this.reactionDetails.countPerReactionType.map(reaction => {
                this.tabs[reaction.reactionTypeId].count = reaction.count;
                })
            $(this.$refs.reactionSummaryModal).modal('show');
            this.setActiveTab(this.tabs[0].id);
            this.infiniteHandler();
        },
        closeModal() {
            $(this.$refs.reactionSummaryModal).modal('hide');
        },
        setActiveTab(selectedTab) {
            this.tabs = this.tabs.map(tab => {
                // set the selected tab to active
                tab.active = tab.id === selectedTab;
                return tab;
            });
            this.reactionsList = [];
            this.page = 1;
            this.infiniteId += 1;
        },
        async infiniteHandler() {
            const query = {
                limit:10,
                desc:false,
                page:this.page
            };
            
            query['f_contentId'] = this.feedId;
            
            if(this.getActiveTab.id!==0){
                query['f_reactionTypeId'] = this.getActiveTab.id;
            }

            ContentReactionService.getReaction(query)
                .then(res => {
                    const { data:{ data, pagination} } = res;

                    if(data.length){
                        this.reactionsList = this.reactionsList.concat(data);
                        this.page = this.page + 1;

                        this.$refs.membersLoader.stateChanger.loaded();

                        if (this.page > pagination.pageCount) {
                            this.$refs.membersLoader.stateChanger.complete();
                        } 

                    } else {
                        this.$refs.membersLoader.stateChanger.complete();
                    }
                })
                .catch (error => {
                    this.$refs.membersLoader.stateChanger.error();
                });
        },
    }
}